module.exports = __webpack_public_path__ + "static/hippogriff-2eed4eae2ac9e9a1b8e266a92c0cd0ad.jpg";